module.exports = __webpack_public_path__ + "static/media/cathy-tindle.df9ce168.jpg";